export enum UserRoleType {
    Undefined = 0,
    Owner = 1,
    Administrator = 2,
    Accountant = 3,
    Auditor = 4,
    Viewer = 5,

    // Trust relationships
    Trustee = 6,
    Beneficiary = 7,
    Settlor = 8,

    // Company Relationships
    Director = 9,
    Shareholder = 10,

    // Partnership/LLP Relationships
    // UnitTrust relationships

    // Advisor Relationships
    Advisor = 11,
    ClientManager = 12,
    ClientAdministrator = 13,

    //Group Relationships
    Group = 14,

    // Delegated Authority Relationships
    AuthorisedRepresentative = 15,
    Child = 16,
    DelegatedAuthority = 17,
    Executor = 18,
    PowerOfAttorney = 19
}
